var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:_vm.componentClass,attrs:{"variant":_vm.btnVariant,"block":_vm.block,"disabled":_vm.disabled},on:{"click":_vm.listener}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }